import React, { useState, useRef, useEffect } from "react";

const ColumnMenu = ({ table }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={menuRef} style={{ position: "relative", display: "inline-block" }}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        ⋮
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            right: 0,
            top: "100%",
            background: "white",
            border: "1px solid #ccc",
            borderRadius: "6px",
            padding: "6px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            zIndex: 10,
          }}
        >
          {table.getAllLeafColumns().filter((col) => col.id !== "select").map((col) => (
            <label
              key={col.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "2px 4px",
              }}
            >
              <input
                type="checkbox"
                checked={col.getIsVisible()}
                onChange={() => col.toggleVisibility()}
              />
              {col.columnDef.header || col.id}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ColumnMenu;
